import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons components

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardHeaderList() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <Box
          component="img"
          alt="..."
          src={require("assets/img/theme/img-1-1000x600.jpg").default}
          sx={{
            borderTopLeftRadius: "calc(.375rem - 1px)",
            borderTopRightRadius: "calc(.375rem - 1px)",
            flexShrink: 0,
            width: "100%",
            verticalAlign: "middle",
            borderStyle: "none",
          }}
        />
        <List disablePadding>
          <ListItem
            sx={{
              padding: "1.5rem!important",
              borderBottom: "1px solid " + theme.palette.gray[200],
            }}
          >
            Cras justo odio
          </ListItem>
          <ListItem
            sx={{
              padding: "1.5rem!important",
              borderBottom: "1px solid " + theme.palette.gray[200],
            }}
          >
            Dapibus ac facilisis in
          </ListItem>
          <ListItem
            sx={{
              padding: "1.5rem!important",
              borderBottom: "1px solid " + theme.palette.gray[200],
            }}
          >
            Vestibulum at eros
          </ListItem>
        </List>
        <CardContent>
          <Box
            component={Typography}
            variant="h3"
            sx={{ marginBottom: "1rem!important" }}
          >
            Card title
          </Box>
          <Box
            component="p"
            sx={{
              marginBottom: "1rem",
              fontWeight: "300",
              lineHeight: "1.7",
              fontSize: "1rem",
              marginTop: "0",
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facilis
            non dolore est fuga nobis ipsum illum eligendi nemo iure repellat,
            soluta, optio minus ut reiciendis voluptates enim impedit veritatis
            officiis.
          </Box>
          <Button variant="contained" color="primary">
            Go somewhere
          </Button>
        </CardContent>
      </Card>
    </>
  );
}

export default CardHeaderList;
